import colorConfig from "./color-config.json";

const COLOR_ENTRIES = colorConfig.colors;

const resolveValue = (compConfig, entry) => {
  const direct = compConfig[entry.configKey];
  if (direct != null) return direct;
  if (entry.fallbackConfigKey) {
    const fallback = compConfig[entry.fallbackConfigKey];
    if (fallback != null) return fallback;
  }
  return null;
};

const setVar = (style, cssVar, value) => {
  if (value != null) style[cssVar] = value;
};

export const buildThemeStyle = (compConfig, hasDataConfig) => {
  if (!hasDataConfig) return {};

  const source = compConfig?.parsedConfig || compConfig;
  if (!source || typeof source !== "object") return {};

  const style = {};

  for (const entry of COLOR_ENTRIES) {
    if (entry.derived) continue;
    const value = resolveValue(source, entry);
    if (value == null) continue;
    setVar(style, entry.cssVar, value);
    if (entry.extraCssVars) {
      for (const extra of entry.extraCssVars) {
        if (entry.configKey === "colorBg" && extra === "--kbv-bg-page") {
          if (source.colorPageBg != null) continue;
        }
        if (entry.configKey === "colorForeground" && extra === "--kbv-card-bg") {
          if (source.colorCardBg != null) continue;
        }
        if (entry.configKey === "colorBorder" && extra === "--kbv-card-border") {
          if (source.colorCardBorder != null) continue;
        }
        if (entry.configKey === "colorTextMuted" && extra === "--text-half-score") {
          if (source.colorHalfScore != null) continue;
        }
        setVar(style, extra, value);
      }
    }
  }

  const primary = source.colorPrimary;
  const highlight = source.colorSecondary;
  const onPrimary = source.colorOnPrimary;

  if (source.colorPrimaryHover == null && highlight != null) {
    setVar(style, "--theme-primary-hover", highlight);
  }

  if (source.colorGlow == null && primary != null) {
    setVar(
      style,
      "--theme-glow",
      `color-mix(in srgb, ${primary} 25%, transparent)`,
    );
  }

  if (source.colorCtaGradient == null && highlight != null && primary != null) {
    setVar(
      style,
      "--theme-cta-gradient",
      `linear-gradient(180deg, ${highlight}, ${primary})`,
    );
  }

  if (source.colorOnCta == null && onPrimary != null) {
    setVar(style, "--theme-on-cta", onPrimary);
  }

  if (source.colorLiveShadow == null && highlight != null) {
    setVar(
      style,
      "--theme-live-shadow",
      `0 0 8px color-mix(in srgb, ${highlight} 25%, transparent)`,
    );
  }

  return style;
};

export { colorConfig };
